module.exports = __webpack_public_path__ + "img/DM.1267da98.svg";